function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, forwardRef, Stack, useAccordionContext, useAccordionItemState } from '@tempo/core';
import { ChevronBottomIcon } from '@tempo/icons';
import { LandingHeading, innerLinkTextStyle } from './LandingTypography';
export const LandingAccordion = forwardRef((_param, ref)=>{
    var { title } = _param, accordionProps = _object_without_properties(_param, [
        "title"
    ]);
    const titleComponent = /*#__PURE__*/ React.isValidElement(title) ? title : /*#__PURE__*/ _jsx(LandingHeading, {
        as: "h2",
        children: title
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            title && titleComponent,
            /*#__PURE__*/ _jsx(Accordion, _object_spread_props(_object_spread({
                ref: ref,
                variant: "faq",
                w: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                allowMultiple: true
            }, accordionProps), {
                children: /*#__PURE__*/ _jsx(Stack, {
                    direction: "column",
                    spacing: {
                        base: 'spacing.s',
                        md: 'spacing.l'
                    },
                    w: "100%",
                    children: accordionProps.children
                })
            }))
        ]
    });
});
export const LandingAccordionItem = (_param)=>{
    var { label, children, titleTag = 'h3', styleLinks = true } = _param, boxProps = _object_without_properties(_param, [
        "label",
        "children",
        "titleTag",
        "styleLinks"
    ]);
    return /*#__PURE__*/ _jsxs(AccordionItem, {
        children: [
            /*#__PURE__*/ _jsxs(AccordionButton, {
                children: [
                    /*#__PURE__*/ _jsx(LandingHeading, {
                        as: titleTag,
                        textAlign: "start",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(LandingAccordionIcon, {})
                ]
            }),
            /*#__PURE__*/ _jsx(AccordionPanel, _object_spread_props(_object_spread({
                pb: "spacing.l",
                pt: {
                    base: 0,
                    md: 'spacing.s'
                },
                sx: styleLinks ? innerLinkTextStyle : undefined,
                textAlign: "start"
            }, boxProps), {
                children: children
            }))
        ]
    });
};
export const LandingAccordionIcon = (props)=>{
    const { isOpen, isDisabled } = useAccordionItemState();
    const { reduceMotion } = useAccordionContext();
    const iconStyles = {
        opacity: isDisabled ? 0.4 : 1,
        transform: isOpen ? 'rotate(-180deg)' : undefined,
        transition: reduceMotion ? undefined : 'transform 0.2s',
        transformOrigin: 'center',
        ms: 'spacing.m'
    };
    return /*#__PURE__*/ _jsx(ChevronBottomIcon, _object_spread({
        size: "medium"
    }, iconStyles, props));
};

//# sourceMappingURL=LandingAccordion.js.map